// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
export var SDK_NAME = 'sentry.javascript.browser';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/browser/esm/version.js
// module id = 478
// module chunks = 1